/**
 * @generated SignedSource<<ee6bafeaff147fca1aa8e35d6f6569ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVAssigneesPopover_assignable$data = {
  readonly assigned: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_EmployeeItem">;
    } | null;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_assignableEmployee">;
  readonly " $fragmentType": "TVAssigneesPopover_assignable";
};
export type TVAssigneesPopover_assignable$key = {
  readonly " $data"?: TVAssigneesPopover_assignable$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_assignable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVAssigneesPopover_assignable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TVAssigneesPopover_EmployeeItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TVAssigneesPopover_assignableEmployee"
    }
  ],
  "type": "Assignable",
  "abstractKey": "__isAssignable"
};

(node as any).hash = "85964d874e47e7b6bf05ad9a419fbd2a";

export default node;
